import { flatten, map, uniq } from 'lodash';

// Helper to extract all unique amenities from units
export function extractAmenities(units) {
	const allAmenities = uniq(flatten(map(units, 'availableAmenities'))).sort();
	return allAmenities.filter(Boolean); // Remove any null/undefined values
}

// Helper to check if unit has specific amenity
export function unitHasAmenity(unit, amenity) {
	const amenities = unit?.availableAmenities || [];
	return amenities.includes(amenity);
}
